import { useParams, Link, useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import { blogPosts } from '../../mocks/blogPosts';

// Teklif Formu Bileşeni
function TeklifForm({ postTitle }: { postTitle: string }) {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    labelType: '',
    quantity: '',
    message: `"${postTitle}" yazısını okudum, etiket baskısı hakkında teklif almak istiyorum.`,
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');
  const [charCount, setCharCount] = useState(formData.message.length);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    if (name === 'message') {
      if (value.length > 500) return;
      setCharCount(value.length);
    }
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (formData.message.length > 500) return;
    setIsSubmitting(true);
    setSubmitStatus('idle');
    try {
      const body = new URLSearchParams();
      Object.entries(formData).forEach(([k, v]) => body.append(k, v));
      const res = await fetch('https://readdy.ai/api/form/d6o07v539lnhn4hh11s0', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: body.toString(),
      });
      setSubmitStatus(res.ok ? 'success' : 'error');
    } catch {
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  if (submitStatus === 'success') {
    return (
      <div className="bg-green-50 border border-green-200 rounded-2xl p-10 text-center">
        <div className="w-16 h-16 flex items-center justify-center bg-green-100 rounded-full mx-auto mb-4">
          <i className="ri-check-line text-3xl text-green-600"></i>
        </div>
        <h3 className="text-xl font-bold text-[#1A2332] mb-2">Teklifiniz Alındı!</h3>
        <p className="text-gray-600 text-sm">En kısa sürede sizinle iletişime geçeceğiz.</p>
      </div>
    );
  }

  return (
    <form
      id="blog-teklif-form"
      data-readdy-form
      onSubmit={handleSubmit}
      className="bg-gradient-to-br from-[#1A2332] to-[#2A3547] rounded-3xl p-8 md:p-10"
    >
      <div className="flex items-center gap-3 mb-2">
        <div className="w-10 h-10 flex items-center justify-center bg-[#FF6B35]/20 rounded-xl">
          <i className="ri-price-tag-3-line text-xl text-[#FF6B35]"></i>
        </div>
        <h3 className="text-2xl font-bold text-white">Ücretsiz Teklif İste</h3>
      </div>
      <p className="text-gray-400 text-sm mb-8 ml-[52px]">
        Formu doldurun, 24 saat içinde size özel fiyat teklifimizi iletiyoruz.
      </p>

      <div className="grid md:grid-cols-2 gap-5">
        <div>
          <label className="block text-xs font-semibold text-gray-400 mb-1.5 uppercase tracking-wide">Ad Soyad *</label>
          <input
            type="text"
            name="name"
            value={formData.name}
            onChange={handleChange}
            required
            placeholder="Adınız Soyadınız"
            className="w-full bg-white/10 border border-white/10 rounded-xl px-4 py-3 text-sm text-white placeholder-gray-500 focus:outline-none focus:border-[#FF6B35] transition-colors"
          />
        </div>
        <div>
          <label className="block text-xs font-semibold text-gray-400 mb-1.5 uppercase tracking-wide">E-posta *</label>
          <input
            type="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            required
            placeholder="ornek@sirket.com"
            className="w-full bg-white/10 border border-white/10 rounded-xl px-4 py-3 text-sm text-white placeholder-gray-500 focus:outline-none focus:border-[#FF6B35] transition-colors"
          />
        </div>
        <div>
          <label className="block text-xs font-semibold text-gray-400 mb-1.5 uppercase tracking-wide">Telefon</label>
          <input
            type="tel"
            name="phone"
            value={formData.phone}
            onChange={handleChange}
            placeholder="+90 5XX XXX XX XX"
            className="w-full bg-white/10 border border-white/10 rounded-xl px-4 py-3 text-sm text-white placeholder-gray-500 focus:outline-none focus:border-[#FF6B35] transition-colors"
          />
        </div>
        <div>
          <label className="block text-xs font-semibold text-gray-400 mb-1.5 uppercase tracking-wide">Etiket Türü</label>
          <select
            name="labelType"
            value={formData.labelType}
            onChange={handleChange}
            className="w-full bg-white/10 border border-white/10 rounded-xl px-4 py-3 text-sm text-white focus:outline-none focus:border-[#FF6B35] transition-colors appearance-none cursor-pointer"
          >
            <option value="" className="bg-[#1A2332]">Seçiniz...</option>
            <option value="Gıda Etiketi" className="bg-[#1A2332]">Gıda Etiketi</option>
            <option value="Kozmetik Etiketi" className="bg-[#1A2332]">Kozmetik Etiketi</option>
            <option value="İlaç Etiketi" className="bg-[#1A2332]">İlaç Etiketi</option>
            <option value="Endüstriyel Etiket" className="bg-[#1A2332]">Endüstriyel Etiket</option>
            <option value="Lojistik Etiketi" className="bg-[#1A2332]">Lojistik Etiketi</option>
            <option value="Özel Tasarım" className="bg-[#1A2332]">Özel Tasarım</option>
          </select>
        </div>
        <div>
          <label className="block text-xs font-semibold text-gray-400 mb-1.5 uppercase tracking-wide">Tahmini Adet</label>
          <input
            type="text"
            name="quantity"
            value={formData.quantity}
            onChange={handleChange}
            placeholder="Örn: 5.000 adet"
            className="w-full bg-white/10 border border-white/10 rounded-xl px-4 py-3 text-sm text-white placeholder-gray-500 focus:outline-none focus:border-[#FF6B35] transition-colors"
          />
        </div>
        <div className="md:col-span-2">
          <label className="block text-xs font-semibold text-gray-400 mb-1.5 uppercase tracking-wide">
            Mesajınız
            <span className="ml-2 font-normal normal-case text-gray-500">({charCount}/500)</span>
          </label>
          <textarea
            name="message"
            value={formData.message}
            onChange={handleChange}
            rows={3}
            maxLength={500}
            placeholder="Etiket ihtiyacınızı kısaca açıklayın..."
            className="w-full bg-white/10 border border-white/10 rounded-xl px-4 py-3 text-sm text-white placeholder-gray-500 focus:outline-none focus:border-[#FF6B35] transition-colors resize-none"
          />
        </div>
      </div>

      {submitStatus === 'error' && (
        <p className="text-red-400 text-sm mt-4">Bir hata oluştu, lütfen tekrar deneyin.</p>
      )}

      <div className="flex flex-col sm:flex-row gap-3 mt-6">
        <button
          type="submit"
          disabled={isSubmitting}
          className="flex-1 py-3.5 bg-[#FF6B35] text-white text-sm font-bold rounded-full hover:bg-[#E55A2B] transition-all disabled:opacity-50 whitespace-nowrap flex items-center justify-center gap-2 cursor-pointer"
        >
          {isSubmitting ? (
            <><i className="ri-loader-4-line animate-spin"></i> Gönderiliyor...</>
          ) : (
            <><i className="ri-send-plane-line"></i> Teklif Gönder</>
          )}
        </button>
        <a
          href="https://wa.me/905326018294?text=Merhaba%2C%20etiket%20bask%C4%B1%20hakk%C4%B1nda%20teklif%20almak%20istiyorum."
          target="_blank"
          rel="nofollow"
          className="flex items-center justify-center gap-2 px-6 py-3.5 border border-white/20 text-white text-sm font-semibold rounded-full hover:border-green-400 hover:text-green-400 transition-all whitespace-nowrap cursor-pointer"
        >
          <i className="ri-whatsapp-line text-green-400"></i>
          WhatsApp ile Yaz
        </a>
      </div>
    </form>
  );
}

// İç Bağlantı Kutusu
function RelatedServices({ links }: { links: { label: string; anchor: string; productId: string | null; icon: string }[] }) {
  const navigate = useNavigate();

  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>, anchor: string) => {
    e.preventDefault();
    const [path, hash] = anchor.split('#');
    const targetPath = path || '/';
    if (window.location.pathname === targetPath || targetPath === '/') {
      navigate(targetPath);
      setTimeout(() => {
        const el = document.querySelector(`#${hash}`);
        if (el) el.scrollIntoView({ behavior: 'smooth' });
      }, 100);
    } else {
      navigate(targetPath);
    }
  };

  return (
    <div className="my-10 bg-gradient-to-br from-orange-50 to-amber-50 border border-orange-100 rounded-2xl p-6">
      <div className="flex items-center gap-2 mb-4">
        <div className="w-8 h-8 flex items-center justify-center bg-[#FF6B35] rounded-lg">
          <i className="ri-links-line text-white text-sm"></i>
        </div>
        <h4 className="text-base font-bold text-[#1A2332]">İlgili Hizmet ve Ürünlerimiz</h4>
      </div>
      <p className="text-sm text-gray-500 mb-5">Bu yazıyla ilgili hizmetlerimizi incelemek veya teklif almak için tıklayın:</p>
      <div className="grid sm:grid-cols-2 gap-3">
        {links.map((link, i) => (
          <a
            key={i}
            href={link.anchor}
            onClick={(e) => handleClick(e, link.anchor)}
            className="flex items-center gap-3 px-4 py-3 bg-white rounded-xl border border-orange-100 hover:border-[#FF6B35] hover:shadow-md transition-all duration-300 group cursor-pointer"
          >
            <div className="w-9 h-9 flex items-center justify-center bg-orange-50 rounded-lg group-hover:bg-[#FF6B35] transition-colors flex-shrink-0">
              <i className={`${link.icon} text-[#FF6B35] group-hover:text-white text-base transition-colors`}></i>
            </div>
            <span className="text-sm font-semibold text-[#1A2332] group-hover:text-[#FF6B35] transition-colors leading-tight">{link.label}</span>
            <i className="ri-arrow-right-line text-gray-300 group-hover:text-[#FF6B35] ml-auto transition-colors text-sm"></i>
          </a>
        ))}
      </div>
    </div>
  );
}

export default function BlogDetail() {
  const { slug } = useParams<{ slug: string }>();
  const [showStickyBar, setShowStickyBar] = useState(false);

  const post = blogPosts.find((p) => p.slug === slug);

  useEffect(() => {
    const handleScroll = () => {
      setShowStickyBar(window.scrollY > 600);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);

    if (!post) return;

    const siteUrl = import.meta.env.VITE_SITE_URL || 'https://www.bioetiket.com';

    document.title = `${post.title} | Bioetiket Blog`;

    let desc = document.querySelector('meta[name="description"]');
    if (!desc) { desc = document.createElement('meta'); desc.setAttribute('name', 'description'); document.head.appendChild(desc); }
    desc.setAttribute('content', post.excerpt.slice(0, 160));

    let kw = document.querySelector('meta[name="keywords"]');
    if (!kw) { kw = document.createElement('meta'); kw.setAttribute('name', 'keywords'); document.head.appendChild(kw); }
    kw.setAttribute('content', post.tags.join(', '));

    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) { canonical = document.createElement('link'); canonical.setAttribute('rel', 'canonical'); document.head.appendChild(canonical); }
    canonical.setAttribute('href', `${siteUrl}/blog/${post.slug}`);

    const ogTags: Record<string, string> = {
      'og:title': `${post.title} | Bioetiket`,
      'og:description': post.excerpt.slice(0, 160),
      'og:url': `${siteUrl}/blog/${post.slug}`,
      'og:type': 'article',
      'og:image': post.image,
    };
    Object.entries(ogTags).forEach(([property, content]) => {
      let tag = document.querySelector(`meta[property="${property}"]`);
      if (!tag) { tag = document.createElement('meta'); tag.setAttribute('property', property); document.head.appendChild(tag); }
      tag.setAttribute('content', content);
    });

    const twitterTags: Record<string, string> = {
      'twitter:title': `${post.title} | Bioetiket`,
      'twitter:description': post.excerpt.slice(0, 160),
      'twitter:image': post.image,
    };
    Object.entries(twitterTags).forEach(([name, content]) => {
      let tag = document.querySelector(`meta[name="${name}"]`);
      if (!tag) { tag = document.createElement('meta'); tag.setAttribute('name', name); document.head.appendChild(tag); }
      tag.setAttribute('content', content);
    });

    const schemaId = 'schema-blog-article';
    const existing = document.getElementById(schemaId);
    if (existing) existing.remove();
    const script = document.createElement('script');
    script.id = schemaId;
    script.type = 'application/ld+json';
    script.text = JSON.stringify({
      '@context': 'https://schema.org',
      '@type': 'Article',
      headline: post.title,
      description: post.excerpt,
      image: post.image,
      datePublished: post.date,
      dateModified: post.date,
      author: { '@type': 'Organization', name: post.author, url: siteUrl },
      publisher: {
        '@type': 'Organization',
        name: 'Bioetiket',
        url: siteUrl,
        logo: { '@type': 'ImageObject', url: `${siteUrl}/og-image.jpg` },
      },
      mainEntityOfPage: { '@type': 'WebPage', '@id': `${siteUrl}/blog/${post.slug}` },
      keywords: post.tags.join(', '),
      articleSection: post.category,
    });
    document.head.appendChild(script);

    const breadcrumbId = 'schema-breadcrumb-article';
    const existingBc = document.getElementById(breadcrumbId);
    if (existingBc) existingBc.remove();
    const bcScript = document.createElement('script');
    bcScript.id = breadcrumbId;
    bcScript.type = 'application/ld+json';
    bcScript.text = JSON.stringify({
      '@context': 'https://schema.org',
      '@type': 'BreadcrumbList',
      itemListElement: [
        { '@type': 'ListItem', position: 1, name: 'Ana Sayfa', item: `${siteUrl}/` },
        { '@type': 'ListItem', position: 2, name: 'Blog', item: `${siteUrl}/blog` },
        { '@type': 'ListItem', position: 3, name: post.title, item: `${siteUrl}/blog/${post.slug}` },
      ],
    });
    document.head.appendChild(bcScript);

    return () => {
      document.title = 'Ümraniye İstanbul Etiket Baskı | Profesyonel Etiket Basım | Bioetiket';
      const s = document.getElementById(schemaId);
      if (s) s.remove();
      const bc = document.getElementById(breadcrumbId);
      if (bc) bc.remove();
    };
  }, [slug, post]);

  const related = blogPosts.filter((p) => p.slug !== slug).slice(0, 3);

  if (!post) {
    return (
      <div className="min-h-screen bg-white flex flex-col">
        <Navbar />
        <div className="flex-1 flex flex-col items-center justify-center py-32">
          <div className="w-16 h-16 flex items-center justify-center mb-4 text-gray-300">
            <i className="ri-article-line text-5xl"></i>
          </div>
          <h2 className="text-2xl font-bold text-[#1A2332] mb-3">Makale Bulunamadı</h2>
          <p className="text-gray-500 mb-6">Aradığınız makale mevcut değil veya kaldırılmış olabilir.</p>
          <Link
            to="/blog"
            className="inline-flex items-center px-6 py-3 text-sm font-semibold text-white bg-[#FF6B35] rounded-full hover:bg-[#E55A2B] transition-all whitespace-nowrap cursor-pointer"
          >
            <i className="ri-arrow-left-line mr-2"></i>
            Blog&apos;a Dön
          </Link>
        </div>
        <Footer />
      </div>
    );
  }

  const paragraphs = post.content.trim().split('\n').filter((line) => line.trim() !== '');

  const renderContent = () => {
    return paragraphs.map((line, idx) => {
      if (line.startsWith('## ')) {
        return <h2 key={idx} className="text-2xl font-bold text-[#1A2332] mt-10 mb-4">{line.replace('## ', '')}</h2>;
      }
      if (line.startsWith('### ')) {
        return <h3 key={idx} className="text-xl font-semibold text-[#1A2332] mt-8 mb-3">{line.replace('### ', '')}</h3>;
      }
      if (line.startsWith('**') && line.endsWith('**')) {
        return <p key={idx} className="font-semibold text-[#1A2332] mt-4 mb-2">{line.replace(/\*\*/g, '')}</p>;
      }
      if (line.startsWith('- ')) {
        return <li key={idx} className="text-gray-700 leading-relaxed ml-4 list-disc">{line.replace('- ', '')}</li>;
      }
      if (/^\d+\./.test(line)) {
        return <li key={idx} className="text-gray-700 leading-relaxed ml-4 list-decimal">{line.replace(/^\d+\.\s/, '')}</li>;
      }
      if (line.startsWith('|')) return null;
      return <p key={idx} className="text-gray-700 leading-relaxed text-base">{line}</p>;
    });
  };

  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      {/* Hero */}
      <section className="pt-32 pb-0">
        <div className="max-w-4xl mx-auto px-6">
          <nav className="flex items-center gap-2 text-sm text-gray-400 mb-8">
            <Link to="/" className="hover:text-[#FF6B35] transition-colors cursor-pointer">Ana Sayfa</Link>
            <i className="ri-arrow-right-s-line"></i>
            <Link to="/blog" className="hover:text-[#FF6B35] transition-colors cursor-pointer">Blog</Link>
            <i className="ri-arrow-right-s-line"></i>
            <span className="text-gray-600 line-clamp-1">{post.title}</span>
          </nav>

          <div className="flex flex-wrap items-center gap-4 mb-6">
            <span className="bg-[#FF6B35] text-white text-xs font-semibold px-4 py-1.5 rounded-full">{post.category}</span>
            <span className="flex items-center gap-1.5 text-sm text-gray-400">
              <i className="ri-calendar-line"></i>
              {new Date(post.date).toLocaleDateString('tr-TR', { day: 'numeric', month: 'long', year: 'numeric' })}
            </span>
            <span className="flex items-center gap-1.5 text-sm text-gray-400">
              <i className="ri-time-line"></i>
              {post.readTime} okuma
            </span>
            <span className="flex items-center gap-1.5 text-sm text-gray-400">
              <i className="ri-user-line"></i>
              {post.author}
            </span>
          </div>

          <h1 className="text-4xl font-bold text-[#1A2332] leading-tight mb-6">{post.title}</h1>
          <p className="text-lg text-gray-600 leading-relaxed mb-10 border-l-4 border-[#FF6B35] pl-5">{post.excerpt}</p>
        </div>

        <div className="max-w-5xl mx-auto px-6 mb-12">
          <div className="w-full h-96 rounded-3xl overflow-hidden shadow-xl">
            <img
              src={post.image}
              alt={post.title}
              className="w-full h-full object-cover object-top"
              loading="eager"
              fetchpriority="high"
              decoding="async"
              width="1200"
              height="600"
            />
          </div>
        </div>
      </section>

      {/* İçerik */}
      <section className="pb-16">
        <div className="max-w-4xl mx-auto px-6">
          <div className="grid lg:grid-cols-3 gap-12">
            {/* Makale */}
            <article className="lg:col-span-2 space-y-4">
              {renderContent()}

              {/* İç Bağlantı Kutusu */}
              {post.relatedLinks && post.relatedLinks.length > 0 && (
                <RelatedServices links={post.relatedLinks} />
              )}

              {/* Etiketler */}
              <div className="pt-8 border-t border-gray-100 mt-10">
                <p className="text-sm font-semibold text-gray-500 mb-3">Etiketler:</p>
                <div className="flex flex-wrap gap-2">
                  {post.tags.map((tag) => (
                    <Link
                      key={tag}
                      to="/blog"
                      className="text-xs px-4 py-2 bg-orange-50 text-[#FF6B35] rounded-full hover:bg-[#FF6B35] hover:text-white transition-all cursor-pointer whitespace-nowrap"
                    >
                      #{tag}
                    </Link>
                  ))}
                </div>
              </div>

              {/* Paylaş */}
              <div className="pt-6 flex items-center gap-4">
                <span className="text-sm font-semibold text-gray-500">Paylaş:</span>
                <a
                  href={`https://wa.me/?text=${encodeURIComponent(post.title + ' - https://bioetiket.com/blog/' + post.slug)}`}
                  target="_blank"
                  rel="nofollow"
                  className="w-9 h-9 flex items-center justify-center bg-green-500 text-white rounded-full hover:bg-green-600 transition-colors cursor-pointer"
                >
                  <i className="ri-whatsapp-line text-lg"></i>
                </a>
                <a
                  href={`https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent('https://bioetiket.com/blog/' + post.slug)}`}
                  target="_blank"
                  rel="nofollow"
                  className="w-9 h-9 flex items-center justify-center bg-[#0077B5] text-white rounded-full hover:bg-[#005f8e] transition-colors cursor-pointer"
                >
                  <i className="ri-linkedin-fill text-lg"></i>
                </a>
                <a
                  href={`https://twitter.com/intent/tweet?text=${encodeURIComponent(post.title)}&url=${encodeURIComponent('https://bioetiket.com/blog/' + post.slug)}`}
                  target="_blank"
                  rel="nofollow"
                  className="w-9 h-9 flex items-center justify-center bg-black text-white rounded-full hover:bg-gray-800 transition-colors cursor-pointer"
                >
                  <i className="ri-twitter-x-line text-lg"></i>
                </a>
              </div>

              {/* ── Teklif Formu ── */}
              <div className="mt-14" id="teklif-form">
                <TeklifForm postTitle={post.title} />
              </div>
            </article>

            {/* Sidebar */}
            <aside className="space-y-8">
              {/* CTA Kartı */}
              <div className="bg-[#1A2332] rounded-2xl p-6 text-white">
                <div className="w-12 h-12 flex items-center justify-center bg-[#FF6B35]/20 rounded-xl mb-4">
                  <i className="ri-price-tag-3-line text-2xl text-[#FF6B35]"></i>
                </div>
                <h4 className="text-lg font-bold mb-2">Ücretsiz Teklif Alın</h4>
                <p className="text-sm text-gray-400 mb-5 leading-relaxed">
                  Etiket ihtiyacınız için hızlı fiyat teklifi ve ücretsiz numune talep edin.
                </p>
                <a
                  href="#teklif-form"
                  className="block text-center py-3 bg-[#FF6B35] text-white text-sm font-semibold rounded-full hover:bg-[#E55A2B] transition-all whitespace-nowrap cursor-pointer"
                >
                  Hemen Teklif Al
                </a>
                <a
                  href="https://wa.me/905326018294?text=Merhaba%2C%20etiket%20bask%C4%B1%20hakk%C4%B1nda%20bilgi%20almak%20istiyorum."
                  target="_blank"
                  rel="nofollow"
                  className="mt-3 flex items-center justify-center gap-2 py-3 border border-white/20 text-white text-sm font-medium rounded-full hover:border-white/50 transition-all whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-whatsapp-line text-green-400"></i>
                  WhatsApp&apos;tan Yaz
                </a>
              </div>

              {/* Hızlı Hizmet Linkleri - Sidebar */}
              <div className="bg-white border border-gray-100 rounded-2xl p-6 shadow-sm">
                <h4 className="text-base font-bold text-[#1A2332] mb-4 flex items-center gap-2">
                  <i className="ri-service-line text-[#FF6B35]"></i>
                  Hizmetlerimiz
                </h4>
                <div className="space-y-2">
                  {[
                    { label: 'Gıda Etiketleri', anchor: '/#services', icon: 'ri-restaurant-line' },
                    { label: 'Kozmetik Etiketleri', anchor: '/#services', icon: 'ri-heart-pulse-line' },
                    { label: 'Endüstriyel Etiketler', anchor: '/#services', icon: 'ri-tools-line' },
                    { label: 'Tüm Ürün Tipleri', anchor: '/#product-types', icon: 'ri-price-tag-3-line' },
                  ].map((item, i) => (
                    <a
                      key={i}
                      href={item.anchor}
                      className="flex items-center gap-2.5 px-3 py-2.5 rounded-xl hover:bg-orange-50 transition-colors group cursor-pointer"
                    >
                      <div className="w-7 h-7 flex items-center justify-center bg-orange-50 rounded-lg group-hover:bg-[#FF6B35] transition-colors flex-shrink-0">
                        <i className={`${item.icon} text-[#FF6B35] group-hover:text-white text-sm transition-colors`}></i>
                      </div>
                      <span className="text-sm text-gray-700 group-hover:text-[#FF6B35] transition-colors font-medium">{item.label}</span>
                      <i className="ri-arrow-right-s-line text-gray-300 group-hover:text-[#FF6B35] ml-auto transition-colors"></i>
                    </a>
                  ))}
                </div>
              </div>

              {/* İletişim */}
              <div className="bg-orange-50 rounded-2xl p-6">
                <h4 className="text-base font-bold text-[#1A2332] mb-4">Hızlı İletişim</h4>
                <div className="space-y-3">
                  <a href="tel:+902163658878" className="flex items-center gap-3 text-sm text-gray-700 hover:text-[#FF6B35] transition-colors cursor-pointer">
                    <div className="w-8 h-8 flex items-center justify-center bg-white rounded-full shadow-sm">
                      <i className="ri-phone-line text-[#FF6B35]"></i>
                    </div>
                    +90 216 365 88 78
                  </a>
                  <a href="mailto:info@bioetiket.com" className="flex items-center gap-3 text-sm text-gray-700 hover:text-[#FF6B35] transition-colors cursor-pointer">
                    <div className="w-8 h-8 flex items-center justify-center bg-white rounded-full shadow-sm">
                      <i className="ri-mail-line text-[#FF6B35]"></i>
                    </div>
                    info@bioetiket.com
                  </a>
                </div>
              </div>

              {/* Diğer Makaleler */}
              <div>
                <h4 className="text-base font-bold text-[#1A2332] mb-4">Diğer Makaleler</h4>
                <div className="space-y-4">
                  {blogPosts.filter((p) => p.slug !== slug).slice(0, 4).map((p) => (
                    <Link key={p.id} to={`/blog/${p.slug}`} className="flex gap-3 group cursor-pointer">
                      <div className="w-16 h-16 flex-shrink-0 rounded-xl overflow-hidden">
                        <img
                          src={p.image}
                          alt={p.title}
                          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
                          loading="lazy"
                          decoding="async"
                          width="200"
                          height="200"
                        />
                      </div>
                      <div className="flex-1">
                        <p className="text-xs text-[#FF6B35] font-medium mb-1">{p.category}</p>
                        <p className="text-sm font-semibold text-[#1A2332] group-hover:text-[#FF6B35] transition-colors leading-snug line-clamp-2">{p.title}</p>
                      </div>
                    </Link>
                  ))}
                </div>
              </div>
            </aside>
          </div>
        </div>
      </section>

      {/* İlgili Makaleler */}
      <section className="py-16 bg-[#FAFAF8]">
        <div className="max-w-7xl mx-auto px-6">
          <h3 className="text-2xl font-bold text-[#1A2332] mb-8">İlgili Makaleler</h3>
          <div className="grid md:grid-cols-3 gap-6">
            {related.map((p) => (
              <Link
                key={p.id}
                to={`/blog/${p.slug}`}
                className="group bg-white rounded-2xl overflow-hidden shadow-md hover:shadow-xl transition-all duration-500 cursor-pointer"
              >
                <div className="h-44 overflow-hidden">
                  <img
                    src={p.image}
                    alt={p.title}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                    loading="lazy"
                    decoding="async"
                    width="600"
                    height="400"
                  />
                </div>
                <div className="p-5">
                  <span className="text-xs font-semibold text-[#FF6B35] uppercase">{p.category}</span>
                  <h4 className="text-base font-bold text-[#1A2332] mt-2 mb-2 group-hover:text-[#FF6B35] transition-colors leading-snug line-clamp-2">{p.title}</h4>
                  <div className="flex items-center gap-2 text-xs text-gray-400">
                    <i className="ri-time-line"></i>
                    {p.readTime} okuma
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>

      <Footer />

      {/* Sticky Alt CTA Bar */}
      <div
        className={`fixed bottom-0 left-0 right-0 z-40 transition-all duration-500 ${
          showStickyBar ? 'translate-y-0 opacity-100' : 'translate-y-full opacity-0'
        }`}
      >
        <div className="bg-[#1A2332] border-t border-white/10 px-6 py-3 flex items-center justify-between gap-4 max-w-full">
          <div className="hidden sm:block">
            <p className="text-white text-sm font-semibold leading-tight">Etiket ihtiyacınız mı var?</p>
            <p className="text-gray-400 text-xs">24 saat içinde size özel teklif hazırlıyoruz.</p>
          </div>
          <div className="flex items-center gap-3 ml-auto">
            <a
              href="https://wa.me/905326018294?text=Merhaba%2C%20etiket%20bask%C4%B1%20hakk%C4%B1nda%20teklif%20almak%20istiyorum."
              target="_blank"
              rel="nofollow"
              className="flex items-center gap-2 px-5 py-2.5 border border-white/20 text-white text-sm font-medium rounded-full hover:border-green-400 hover:text-green-400 transition-all whitespace-nowrap cursor-pointer"
            >
              <i className="ri-whatsapp-line text-green-400"></i>
              WhatsApp
            </a>
            <a
              href="#teklif-form"
              onClick={() => setShowStickyBar(false)}
              className="flex items-center gap-2 px-6 py-2.5 bg-[#FF6B35] text-white text-sm font-bold rounded-full hover:bg-[#E55A2B] transition-all whitespace-nowrap cursor-pointer"
            >
              <i className="ri-price-tag-3-line"></i>
              Teklif İste
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
